import CustomSelect from 'components/CustomSelect'
import { GET, httpOk, POST } from 'helpers/api'
import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { ReactComponent as PlusIcon } from 'assets/icons/plus.svg';

const initData = {
    warehouse_id: '',
    priority: 'low',
    comment: '',
    items: []
}

function RequestRaw({ modal, setModal, rawMaterial }) {
    const { t } = useTranslation()

    const [sendData, setSendData] = useState(structuredClone(initData))

    const [rawMaterials, setRawMaterials] = useState([]);

    async function create() {
        var sendDataCopy = { ...sendData }
        if (!sendDataCopy.warehouse_id) {
            delete sendDataCopy.warehouse_id;
        }
        const response = await POST(`/production/request-raw/`, sendDataCopy)
        if (httpOk(response)) {
            setModal(false);
            setSendData(structuredClone(initData))
        }
    }

    async function addToList() {
        var sendDataCopy = { ...sendData };
        sendDataCopy.items.push({
            raw_material_id: '',
            quantity: '',
        })
        setSendData(sendDataCopy);
    }

    function handleChange(e) {
        var sendDataCopy = { ...sendData };
        sendDataCopy[e.target.name] = e.target.value;
        setSendData(sendDataCopy);
    }

    function selectRawMaterial(option, index) {
        var sendDataCopy = { ...sendData };
        sendDataCopy.items[index].raw_material_id = option.id;
        setSendData(sendDataCopy);
    }

    function handleChangeItem(e, index) {
        var sendDataCopy = { ...sendData };
        sendDataCopy.items[index][e.target.name] = e.target.value;
        setSendData(sendDataCopy);
    }

    useEffect(() => {
        if (modal) {
            var sendDataCopy = structuredClone(initData);
            sendDataCopy.items.push({
                raw_material_id: rawMaterial?.id,
                quantity: '',
            })
            setSendData(sendDataCopy);
        } else {
            setTimeout(() => {
                setSendData(structuredClone(initData));
            }, 100);
        }
    }, [modal, rawMaterial]);

    useEffect(() => {
        async function getRawMaterials() {
            const response = await GET('/catalogs/raw-materials/')
            if (httpOk(response)) {
                setRawMaterials(response.data)
            }
        }

        getRawMaterials()
    }, []);

    return (
        <>
            <Modal show={modal} centered onHide={() => setModal(false)}>
                <i className="uil-times" onClick={() => setModal(false)}></i>
                <div className="modal-title mb-12">
                    {t('create_purchase_request')}
                </div>
                <div className="modal-subtitle mb-32">
                    {t('create_restock_request_desc')}
                </div>

                <div className="d-flex flex-column gap-16 mb-32">
                    <div className="form-group">
                        <label>{t('comment')}</label>
                        <input type="text" placeholder={t('additional_info')} name='comment'
                            value={sendData.comment} onChange={(e) => handleChange(e)} />
                    </div>

                    {sendData.items.map((item, index) => (
                        <React.Fragment key={index}>
                            <hr className="second" />
                            <div className="form-group">
                                <label>{t('raw_material')}</label>
                                <CustomSelect
                                    options={rawMaterials}
                                    value={rawMaterials?.find(option => option.id === item?.raw_material_id) || ''}
                                    onChange={(option) => selectRawMaterial(option, index)}
                                    getOptionLabel={(option) => option.name}
                                    getOptionValue={(option) => option.id}
                                    placeholder={t('select_raw_material')}
                                    isDisabled={rawMaterial?.id}
                                />
                            </div>
                            <div className="form-group">
                                <label>{t('required_quantity')}</label>
                                <input type="text" placeholder='0' name='quantity'
                                    value={item.quantity} onChange={(e) => handleChangeItem(e, index)} />
                            </div>
                        </React.Fragment>
                    ))
                    }

                    {!rawMaterial?.id &&
                        <button className="dark" onClick={() => addToList()}>
                            <PlusIcon />
                            {t('add')}
                        </button>
                    }

                </div>

                <div className="modal-footer">
                    <button className="white" onClick={() => setModal(false)}>
                        {t('cancel')}
                    </button>
                    <button className="dark" onClick={create}>
                        {t('create_request')}
                    </button>
                </div>
            </Modal>
        </>
    )
}

export default RequestRaw